import { FC } from 'react';

import { Flex, Link } from '@rover/kibble/core';

type Props = {
  href: string;
  children: React.ReactNode;
};

const DesktopOurServicesItem: FC<Props> = ({ href, children }) => {
  return (
    <Link href={href} target="_blank" variant="secondary" size="100" underline={false}>
      <Flex flexDirection="column" alignItems="center" justifyContent="center" gap="2x">
        {children}
      </Flex>
    </Link>
  );
};

export default DesktopOurServicesItem;
